export function createFilter<T extends object>(filter: T) {
  const params = new URLSearchParams();

  Object.entries(filter).forEach(([key, value]) => {
    if (value === null || value === undefined) return;
    const paramValue = Array.isArray(value) ? value.join(",") : value.toString();
    params.set(key, paramValue);
  });

  return params;
}

export type PaginatedResponse<T> = {
  count: number;
  page: number;
  pages: number;
  results: Array<T>;
  searchterm?: string;
  size: number;
  total: number;
};
